import { VoucherComment } from './Comments';
import { Rule } from './Rules';

export type Status = 'used' | 'active' | 'cancel' | 'inactive' | 'expired';
export type Entity =
  | 'flix_brazil'
  | 'flix_se'
  | 'flix_chile'
  | 'flix_india'
  | 'flix_mexico'
  | 'flix_inc'
  | 'kamil_koc';

export interface Voucher {
  id: string;
  code: string;
  createdAt: string;
  updatedAt: string | null;
  createdBy: string | null;
  discountType: DiscountType;
  multiUsage: boolean;
  prefix: string;
  specification?: string | null;
  status: Status;
  validityInterval: {
    validSince: string;
    validUntil: string;
  };
  rules?: Rule[];
  entity?: Entity | null;
  comments: VoucherComment[];
}

export interface Batch {
  id: string;
  batchSize: number;
  remainingSize: number;
  status: Status;
  details: {
    codeLength: number;
    prefix: string;
    discountType: DiscountType;
    multiUsage: boolean;
    author: string;
  };
  createdAt: string;
  updatedAt: string | null;
  startedAt: string;
}

export interface BaseDiscount {
  type: string;
}

export interface CreditAmountType extends BaseDiscount {
  type: 'credit_amount';
  credit: {
    amount: number;
    currency: string;
  };
}

export interface FreeRideMarketingType extends BaseDiscount {
  type: 'free_ride_marketing';
  quantity: number;
}

export interface FreeLuggageMarketingType extends BaseDiscount {
  type: 'free_luggage';
  quantity: number;
}

export interface FreeBikeMarketingType extends BaseDiscount {
  type: 'free_bike';
  quantity: number;
}

export interface FreeRideHybridType extends BaseDiscount {
  type: 'free_ride_hybrid';
  quantity: number;
  credit: {
    amount: number;
    currency: string;
  };
}

export interface FreeSeatMarketingType extends BaseDiscount {
  type: 'free_seat';
  quantity: number;
}

export interface PercentageMarketingType extends BaseDiscount {
  type: 'percentage_marketing';
  percentage: number;
}

export interface ValueHybridType extends BaseDiscount {
  type: 'value_hybrid';
  credit: {
    amount: number;
    currency: string;
  };
  discount: {
    amount: number;
    currency: string;
  };
}

export interface ValueMarketingType extends BaseDiscount {
  type: 'value_marketing';
  discount: {
    amount: number;
    currency: string;
  };
}

export type DiscountType =
  | CreditAmountType
  | FreeRideMarketingType
  | FreeLuggageMarketingType
  | FreeBikeMarketingType
  | FreeRideHybridType
  | FreeSeatMarketingType
  | PercentageMarketingType
  | ValueMarketingType
  | ValueHybridType;

export const DiscountTypeMap: Record<DiscountType['type'], string> = {
  credit_amount: 'Credit',
  free_ride_marketing: 'Free ride',
  free_luggage: 'Free luggage',
  free_bike: 'Free bike',
  free_ride_hybrid: 'Free ride hybrid',
  free_seat: 'Free seat',
  percentage_marketing: 'Percentage discount',
  value_hybrid: 'Value hybrid',
  value_marketing: 'Value discount',
};
